import { BaseService } from "./base.service";
import { IProgrammeByErpDBCompany } from "models/ProgrammeModel";
import { IProgrammeList } from "models/Programme/ProgrammeListModel";
import { TableFilterModel } from "models/TableFilterModel";
import { IProgrammeGridDetail } from "models/Programme/ProgrammeGridDetailModel";
import { IProgrammeStatus } from "models/Programme/ProgrammeStatusModel";
import ProgrammeDetailModel, {
	IDepartmentByProgrammeId,
} from "models/Programme/ProgrammeDetailModel";
import { KeyFilterModel } from "models/SystemScheduler/SystemSchedulerFilterModel";
import { IProgrammeDeptByErpDbCompany } from "models/Budget/BudgetAllocationDetail";

class ProgrammeServiceInternal extends BaseService {
	getProgrammeByErpDbCompanyId = async (
		erpDbCompanyIds: string,
		alreadySelectedProgrammeId: number = 0
	): Promise<IProgrammeByErpDBCompany[]> =>
		this.callApi<IProgrammeByErpDBCompany[]>(
			`Programme/GetProgrammeByErpDbCompanyId/${erpDbCompanyIds}`,
			"GET",
			new URLSearchParams({
				alreadySelectedProgrammeId: alreadySelectedProgrammeId.toString(),
			})
		);

	getAllProgrammeList = async (statusIds = ""): Promise<IProgrammeList[]> =>
		this.callApi<IProgrammeList[]>(
			`Programme/GetProgrammeList`,
			"GET",
			new URLSearchParams({
				statusIds: statusIds,
			})
		);

	getProgrammeStatusList = async (): Promise<IProgrammeStatus[]> =>
		this.callApi<IProgrammeStatus[]>(
			`ProgrammeStatus/GetProgrammeStatusList`,
			"GET"
		);

	getProgrammeGridList = async (
		model: TableFilterModel
	): Promise<IProgrammeGridDetail[]> =>
		this.callApi<IProgrammeGridDetail[]>(
			`Programme/GetAllProgrammeList`,
			"POST",
			undefined,
			model
		);

	getProgrammeDetail = async (
		programmeId: number
	): Promise<ProgrammeDetailModel> =>
		this.callApi<ProgrammeDetailModel>(
			`Programme/GetProgrammeData/${programmeId}`,
			"GET"
		);

	saveProgrammeDetail = async (
		model: ProgrammeDetailModel
	): Promise<{ programmeId: number; programmeNumber: string }> =>
		this.callApi<{ programmeId: number; programmeNumber: string }>(
			`Programme/Save`,
			"POST",
			undefined,
			model
		);

	updateProgrammeDetail = async (
		model: ProgrammeDetailModel
	): Promise<undefined> =>
		this.callApi<undefined>(
			`Programme/Update/${model.programmeId}`,
			"PUT",
			undefined,
			model
		);

	deleteProgrammeDetail = async (programmeId: number): Promise<undefined> =>
		this.callApi<undefined>(
			`Programme/Delete/${programmeId}`,
			"DELETE",
			undefined,
			undefined,
			true
		);

	getProgrammeDepartmentList = async (
		model: KeyFilterModel
	): Promise<IDepartmentByProgrammeId[]> =>
		this.callApi<IDepartmentByProgrammeId[]>(
			`ProgrammeDepartment/GetProgrammeDepartmentList`,
			"POST",
			undefined,
			model
		);

	deleteProgrammeDepartment = async (
		programmeDepartmentId: number
	): Promise<boolean> =>
		this.callApi<boolean>(
			`ProgrammeDepartment/Delete/${programmeDepartmentId}`,
			"DELETE"
		);

	checkProgrammeAlreadyUsed = async (programmeId: number): Promise<boolean> =>
		this.callApi<boolean>(
			`Programme/CheckProgrammeAlreadyUsed/${programmeId}`,
			"GET"
		);

	getProgrammeDepartmentListByErpDbCompanyId = async (
		erpDbCompanyId: number,
		financialYearId: number
	): Promise<IProgrammeDeptByErpDbCompany[]> =>
		this.callApi<IProgrammeDeptByErpDbCompany[]>(
			`Programme/GetProgrammeDepartmentListByErpDbCompanyId/${erpDbCompanyId}/${financialYearId}`,
			"GET"
		);

	getProgrammesByContractId = async (
		contractId: number
	): Promise<IProgrammeByErpDBCompany[]> =>
		this.callApi<IProgrammeByErpDBCompany[]>(
			`ContractLine/GetProgrammesByContractId/${contractId}`,
			"GET"
		);
}

export const ProgrammeService = new ProgrammeServiceInternal();
